// extracted by mini-css-extract-plugin
export default {"banner":"FreeRelatedOrdersBanner_banner__sbq55"};